/**
 * @flow
 * @author: Vamsi
 */

import styled from 'react-emotion'

export const CloseIconWrapper = styled('div')`
  user-select: none;
  cursor: pointer;
  position: absolute;
  right: 5%;
  top: 4%;
  @media only screen and (max-width: 767px) {
    position: absolute;
    right: 6%;
    top: 6%;
    padding: 10px;
    padding-bottom: 0px;
  }
`



// WEBPACK FOOTER //
// ./src/commons/BaseModalContainer/styledComponents.js